import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_CAPITALSTATE}`

export default () => http.get(`${api}/operation/cartera-proveedor`)
